import { render } from "./assetcategorylist.vue?vue&type=template&id=ea810af4"
import script from "./assetcategorylist.vue?vue&type=script&lang=js"
export * from "./assetcategorylist.vue?vue&type=script&lang=js"

import "./assetcategorylist.vue?vue&type=style&index=0&id=ea810af4&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\EngeeGit\\EngeeAPI\\AdminPanel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__